module.exports = __webpack_public_path__ + "assets/img/search.4f3f3f04.svg";